/**
 * Normalise la réponse paginée GET /commercants.
 */
export function normalizeCommercantsResponse(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return data.data || data.commercants || [];
}
